const spreadsheetExtensions = [
  "xlsx",
  "xlsm",
  "xlsb",
  "xltx",
  "xltm",
  "xls",
  "csv",
  "ods",
  "ots",
  "xlsm",
];

const imageExtensions = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "bmp",
  "tiff",
  "svg",
  "webp",
];

const audioExtensions = [
  "mp3",
  "wav",
  "flac",
  "m4a",
  "aac",
  "ogg",
  "wma",
  "opus",
  "mpga",
];

export const getFileExtensionStyle = (fileExtension, baseStyle = {}) => {
  const fileExtensionStyle = {};

  if (fileExtension == "pdf") {
    fileExtensionStyle.backgroundColor = "#EE34341A";
    fileExtensionStyle.color = "#EE3434";
  }

  if (spreadsheetExtensions.includes(fileExtension)) {
    fileExtensionStyle.backgroundColor = "#02AE3E1A";
    fileExtensionStyle.color = "#02AE3E";
  }

  if (imageExtensions.includes(fileExtension)) {
    fileExtensionStyle.backgroundColor = "#FFB8001A";
    fileExtensionStyle.color = "#FFB800";
  }

  if (audioExtensions.includes(fileExtension)) {
    fileExtensionStyle.backgroundColor = "#009EDE1A";
    fileExtensionStyle.color = "#009EDE";
  }

  return { ...baseStyle, ...fileExtensionStyle };
};
